export const GET_ACTIONS = "GET_ACTIONS"
export const GET_ACTIONS_FAIL = "GET_ACTIONS_FAIL"
export const GET_ACTIONS_SUCCESS = "GET_ACTIONS_SUCCESS"

export const ADD_NEW_ACTION = "ADD_NEW_ACTION"
export const ADD_ACTION_SUCCESS = "ADD_ACTION_SUCCESS"
export const ADD_ACTION_FAIL = "ADD_ACTION_FAIL"

export const UPDATE_ACTION = "UPDATE_ACTION"
export const UPDATE_ACTION_SUCCESS = "UPDATE_ACTION_SUCCESS"
export const UPDATE_ACTION_FAIL = "UPDATE_ACTION_FAIL"

export const DELETE_ACTION = "DELETE_ACTION"
export const DELETE_ACTION_SUCCESS = "DELETE_ACTION_SUCCESS"
export const DELETE_ACTION_FAIL = "DELETE_ACTION_FAIL"





